<mat-dialog-content>
  <div class="modal-content">
    <div class="modal-body p-0 rating-buttons d-block m-auto text-center">
      @if (qualification()) {
        <app-rating
          class="d-block mb-4"
          [marginAuto]="true"
          [box]="false"
          [showRatingNumber]="false"
          [gray]="false"
          size="40px"
          [qualification]="qualification()"
          (qualificationChange)="onQualification($event)"
        />
      }
      <div class="d-flex flex-column">
        <button class="red mb-2 mx-auto w-100" (click)="close(true)">
          {{ 'eliminar_calificacion' | translate }}
        </button>
        <button class="yellow mx-auto w-100" (click)="close(false)">
          {{ 'actualizar' | translate }}
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
